import logo from '../../images/readyly_logo.png';
import React from 'react';

const ReadylyHeader = () => {
    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", backgroundColor: "#001d4f", padding: "10px 20px", gap: "15px", flexWrap: "wrap", textAlign: "center" }}>
            <img src={logo} alt="Readyly Logo" style={{ width: "40px", height: "auto", minWidth: "30px", flexShrink: 0 }} />
            <h1 style={{ color: "white", fontWeight: 300, fontSize: "1.5rem", margin: 0 }}>
                Readyly Agent Assist
            </h1>
        </div>
    );
};

export default ReadylyHeader;
